
import { defineComponent } from "vue";

import {
    CarouseImg,
    HomeOrganizeActivitiy,
    HomePage,
} from "@/api/organizeActivitiyApi";

import runEvn from "@/modular/runEvn/RunEvn";
const { fileBaseUrl } = runEvn();

export default defineComponent({
    data() {
        return {
            carouseImgs: [],

            activeItems: [],

            activeContentItemRefs: [] as any,

            flowHeight: [0, 0] as any,

            homePage: {},

            activePageObj: {
                pageNum: 1,
                pageSize: 10,
            },

            bannerPageObj: {
                pageNum: 1,
                pageSize: 10,
                carouselmgType: 4,
            },

            assetImg: {
                "star-smile-fill": require("@/assets/image/activity/star-smile-fill.png"),
                "contacts-fill": require("@/assets/image/activity/contacts-fill.png"),
            },
        };
    },

    async mounted() {
        this.loadHomePage();
        this.loadBanner();

        // await this.loadHomeOrganizeActivitiy();
        // await this.loadImg();
        // this.waterfall();
    },

    methods: {
        img(key: string) {
            return fileBaseUrl + key.split(",")[0];
        },
        setItemRef(el: any) {
            // ref数组貌似有问题，会出现重复push的问题，需要判断数组是否存在，存在直接返回
            if (this.activeContentItemRefs.indexOf(el) >= 0) return;
            this.activeContentItemRefs.push(el);
        },
        async loadImg() {
            const imgSize = [];
            let carouseImgs = [...this.activeItems];

            const { pageNum, pageSize } = this.activePageObj;
            carouseImgs = carouseImgs.slice(
                (pageNum - 1) * pageSize,
                pageNum * pageSize
            );

            return await new Promise(async (reslove) => {
                for (let index = 0; index < carouseImgs.length; index++) {
                    let imgObj = () => {
                        return new Promise((reslove) => {
                            const img = new Image();
                            img.src = this.img(carouseImgs[index].img);
                            img.onload = function () {
                                reslove({
                                    width: img.width,
                                    height: img.height,
                                });
                            };
                        });
                    };
                    imgSize.push(await imgObj());
                }

                reslove(imgSize);
            });
        },

        waterfall() {
            let activeRef: Array<any> = [...this.activeContentItemRefs];
            const { pageNum, pageSize } = this.activePageObj;

            activeRef = activeRef.slice(
                (pageNum - 1) * pageSize,
                pageNum * pageSize
            );

            const flowHeight = this.flowHeight;

            activeRef.forEach((element) => {
                console.log("element.clientHeight :>> ", element.clientHeight);
                if (flowHeight[0] > flowHeight[1]) {
                    element.className += " right";
                    element.style.top = flowHeight[1] + "px";
                    flowHeight[1] = flowHeight[1] + element.clientHeight;
                } else {
                    element.style.top = flowHeight[0] + "px";
                    flowHeight[0] = flowHeight[0] + element.clientHeight;
                }

                element.style.visibility = "visible";
            });
        },

        async loadHomePage() {
            const response = await HomePage();
            const responsetest = {
                actTime: 2354687,
                organizationCount: 1245879,
                userCount: 4688623,
            };

            this.homePage = response;
        },

        async loadBanner() {
            const params = {
                ...this.bannerPageObj,
            };
            const response = (await CarouseImg(params)) || { rows: [] };

            const responsetest = {
                rows: [
                    {
                        id: "xxx0",
                        imgKey: "cCwuL3AvMjAyMjA3MTQvMjMxMS8xOCxvdmFoeXN4Zy5xd3oucG5n",
                        title: "哈哈哈",
                        url: "https://www.baidu.com",
                        isOpen: true,
                        sortBy: 0,
                        carouseImgType: 1,
                        videoUrl:
                            "https://www.runoob.com/try/demo_source/movie.mp4",
                        tenantId: "string",
                        appId: "string",
                    },

                    {
                        id: "xxx1",
                        imgKey: "cCwuL3AvMjAyMjA3MTQvMjMxMS8xOCxvdmFoeXN4Zy5xd3oucG5n",
                        title: "哈哈哈",
                        url: "https://www.baidu.com",
                        isOpen: true,
                        sortBy: 0,
                        carouseImgType: 1,
                        tenantId: "string",
                        appId: "string",
                    },
                ],
            };
            this.carouseImgs = this.carouseImgs.concat(response.rows);
        },

        async loadHomeOrganizeActivitiy({ index, setData }) {
            const params = {
                ...this.activePageObj,
            };
            const response = (await HomeOrganizeActivitiy(params)) || {
                rows: [],
            };
            setData(response.rows, response.total);
            this.activeContentItemRefs = [];
            this.activeItems = this.activeItems.concat(response.rows);
            await this.loadImg();
            setTimeout(() => {
                this.waterfall();
            }, 300);
        },

        goToFindOrganization() {
            this.$router.push("/volunteerActive/findOrganization");
        },

        goToFindActives() {
            this.$router.push("/volunteerActive/findActives");
        },

        goToActivityDescription(item: { id: string }) {
            this.$router.push({
                path: "/volunteerActive/activityDescription",
                query: { id: item.id },
            });
        },

        goToUrl(item: any) {
            if (item.videoUrl) {
                window.location.href = item.videoUrl;
                return;
            }

            if (item.url) {
                window.location.href = item.url;
            }
        },

        formatData() {
            const formatUserCount = (data: number | string) => {
                if (data == undefined) return "";

                if (typeof data == "string") {
                    data = Number(data);
                }

                const _data: string = data.toLocaleString();

                const userCount: Array<any> = [];

                if (_data.length <= 3) {
                    return _data;
                }

                // 人数第一个数字
                userCount[0] = _data[0];

                // 人数除了第一个数字后面的其他数字
                userCount[1] = _data.slice(1, _data.length);

                return userCount;
            };

            // 把数据转成小时，这里是秒
            const formatToHour = (data: number | string) => {
                if (data == undefined) return "";

                if (typeof data == "string") {
                    data = Number(data);
                }

                data = data / 3600;

                // 先把小时换算出来，然后保留两位小数，然后通过小数点分割成数组
                const hourArr = parseFloat(data.toFixed(2))
                    .toString()
                    .split(".");

                if (hourArr[1]) {
                    hourArr[1] = "." + hourArr[1];
                } else {
                    // 如果没有小数点，后面这个就传空字符串
                    hourArr[1] = "";
                }

                return hourArr;
            };

            return {
                formatUserCount,
                formatToHour,
            };
        },
    },
});
